<template>
    <hr :class="theme.separator" />
</template>
<script>
    import theme from './separator.scss'

    export default {
        name: 'separator',
        props: {
            theme: {
                type: Object,
                default() {
                    return theme;
                }
            }
        },
    }
</script>


// WEBPACK FOOTER //
// Separator.vue?0e8f31b0